import {Box, Grid, Tab, TextField, Typography} from "@material-ui/core";
import * as React from "react";
import {useEffect, useState} from "react";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {CashService} from "./CashService";
import moment from "jalali-moment";
import {convertCurrencyFormat, convertToBirthDate} from "../../utils/numberConvertor";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {TabContext, TabList, TabPanel} from "@material-ui/lab";
import avatar from "../../assets/images/date.svg"
import {css} from "@emotion/css";
import ReportItems, {ReportsItemTypes} from "../../component/reportItem/ReportItems";
import {RaikoMoneyInputOutlined} from "@moeindal/base-raiko-panel-components";


const CashInfo = () => {
    const snackbarState = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()
    const loading = useLoadingDispatcher()

    const service = new CashService(token, loading, snackbarState, fundID)

    useEffect(() => {
        if (typeof token !== 'undefined' && token !== null) {
            getCashInfoFromServer()
        }
    }, [])

    function getCashInfoFromServer() {
        loading(setLoadingStateDispatch(true))

        service.getCashInfo(fundID)
            .then(response => {
                setFundCode(response.id)
                setName(response.name)
                setMuxNumGroup(response.maximumGroupNumber)
                setMonthlyMeetingDay(response.dateOfMeetingPerMonth)
                setMinimumAmount(response.minimumAmountReceivedPerMonth)
                setLastDay(response.theLastDayAllowedToReceiveSavingsPerMonth)
                setAddress(response.postalAddress)
                setActivityStartDate(response.activityStartDate ? moment(response.activityStartDate, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : "")
                setFixedFeeRate(response.fixedFeeRate)
                setMinimumAmount(response.minimumAmountReceivedPerMonth)

                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت اطلاعات صندوق", snackbarState, loading)
        })
    }

    //state-start
    const [fundCode, setFundCode] = useState('')
    const [name, setName] = useState('')
    const [muxNumGroup, setMuxNumGroup] = useState('')
    const [monthlyMeetingDay, setMonthlyMeetingDay] = useState("")
    const [fixedFeeRate, setFixedFeeRate] = useState('')
    const [activityStartDate, setActivityStartDate] = useState('')
    const [minimumAmount, setMinimumAmount] = useState('')
    const [lastDay, setLastDay] = useState('')
    const [address, setAddress] = useState('')

    //state-end

    function updateFundInfo() {
        if (checkFieldConditions()) {
            service.updateFundInfo(
                service.prepareFundInfoData(
                    name,
                    muxNumGroup,
                    monthlyMeetingDay,
                    fixedFeeRate,
                    activityStartDate,
                    minimumAmount,
                    lastDay,
                    address
                ),
                fundID
            )
        }
    }

    function checkFieldConditions() {
        let state = true
        let message = ""
        if (name.trim().length === 0) {
            state = false
            message = "لطفا نام صندوق را مشخص نمایید!"
        } else if (muxNumGroup.length === 0) {
            state = false
            message = "لطفا حداکثر تعداد گروه را مشخص نمایید!"
        } else if (monthlyMeetingDay.length === 0) {
            state = false
            message = "لطفا روز جلسات ماهانه را مشخص نمایید!"
        } else if (fixedFeeRate.length === 0) {
            state = false
            message = "لطفا درصد کارمزد ثابت را مشخص نمایید!"
        } else if (activityStartDate.length !== 10) {
            state = false
            message = "لطفا تاریخ شروع فعالیت صندوق را مشخص نمایید!"
        } else if (minimumAmount.length === 0) {
            state = false
            message = "لطفا حداقل مبلغ واریز ماهانه را مشخص نمایید!"
        } else if (lastDay.length === 0) {
            state = false
            message = "لطفا آخرین روز مجاز واریز را مشخص نمایید!"
        } else if (address.length === 0) {
            state = false
            message = "لطفا آدرس صندوق را مشخص نمایید!"
        }

        snackbarState(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))
        return state
    }

    const [selectedTab, setSelectedTab] = useState(tabTypes.INFO);

    function handleTabChange(event, newValue) {
        setSelectedTab(newValue);
    }

    function doDownloadReportFile(type) {
        service.getCashReports(type, name)
    }

    return (
        <section className="pageContainer mt-sm-3">

            <Box className="accountDetailsHeader">
                <section className="accountDetailsHeader-title">
                    <Typography variant={"h5"}>
                        جزئیات صندوق
                    </Typography>
                </section>
            </Box>

            <TabContext value={selectedTab}>
                <TabList onChange={handleTabChange} id="default-tab-container">
                    <Tab
                        label={"مشخصات"}
                        value={tabTypes.INFO}
                        /*   iconPosition="start"
                           icon={<div id="tabIcon" className={"profile"}/>}*/
                    />
                    <Tab
                        label={"گزارشات"}
                        value={tabTypes.REPORTS}
                    />
                </TabList>
                <TabPanel value={tabTypes.INFO}>
                    <Box className={`flex-grow-1 w-100 ${css`
                      margin-top: 1rem !important;
                    `}`} sm={12}>
                        <Grid className='d-flex flex-row flex-wrap flex-grow-1 w-100' sm={12}
                              style={{marginTop: '1rem'}}>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" disabled={true} label="کد صندوق"
                                           value={convertCurrencyFormat(fundCode)}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="نام صندوق"
                                           value={name} onChange={e => {
                                    setName(e.target.value)
                                }}/>
                            </Grid>
                            {/*<Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                        <TextField className='w-100' variant="outlined" label="موجودی"
                                   disabled={true}
                                   value={inventory} onChange={e => {
                            setInventory(e.target.value)
                        }}/>
                    </Grid>*/}
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <RaikoMoneyInputOutlined
                                    className='w-100'
                                    variant="outlined"
                                    labelText="حداقل مبلغ واریز پس انداز (ریال)"
                                    value={muxNumGroup}
                                    setValue={setMuxNumGroup}
                                />
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="روز جلسات ماهانه"
                                           value={monthlyMeetingDay}
                                           onChange={e => {
                                               const day = e.target.value
                                               if (day === "" || (day <= 31 && day > 0))
                                                   setMonthlyMeetingDay(day)
                                           }}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="نرخ کارمزد ثابت (درصد)"
                                           value={fixedFeeRate}
                                           onChange={e => {
                                               const percent = e.target.value
                                               if (percent === "" || (percent <= 100 && percent >= 0))
                                                   setFixedFeeRate(percent)
                                           }}/>
                            </Grid>
                            <Grid sm={6} md={4} lg={4} xl={4} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="تاریخ شروع فعالیت"
                                           value={convertToBirthDate(activityStartDate)}
                                           onChange={e => {
                                               setActivityStartDate(convertToBirthDate(e.target.value))
                                           }}/>
                            </Grid>
                            <Grid sm={6} md={6} lg={6} xl={6} className='p-2 w-100'>
                                <RaikoMoneyInputOutlined
                                    className='w-100'
                                    variant="outlined"
                                    labelText="حداقل مبلغ واریز پس انداز (ریال)"
                                    value={minimumAmount}
                                    setValue={setMinimumAmount}
                                    />
                            </Grid>
                            <Grid sm={6} md={6} lg={6} xl={6} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="تاریخ آخرین روز مجاز واریز"
                                           value={lastDay}
                                           onChange={e => {
                                               const day = e.target.value
                                               if (day === "" || (day <= 31 && day > 0))
                                                   setLastDay(day)
                                           }}/>
                            </Grid>
                            <Grid sm={12} md={12} lg={12} xl={12} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="آدرس"
                                           value={address} onChange={e => {
                                    setAddress(e.target.value)
                                }}/>
                            </Grid>
                            {/* <Grid sm={12} md={12} lg={12} xl={12} className='p-2 w-100'>
                                <TextField className='w-100' variant="outlined" label="مجوز درگاه پرداخت"
                                           value={paymentMerchant} onChange={e => {
                                    setPaymentMerchant(e.target.value)
                                }}/>
                            </Grid>*/}
                        </Grid>
                        <section className="account-details-header-button-section">
                            <button className="btn-secondary" onClick={getCashInfoFromServer}>انصراف
                            </button>
                            <button className="btn-confirm" style={{marginRight: "1rem"}}
                                    onClick={updateFundInfo}>بروزرسانی
                            </button>
                        </section>
                    </Box>
                </TabPanel>

                <TabPanel value={tabTypes.REPORTS}>
                    <section className={css`
                      margin-top: 1rem;
                    `}>
                        <ReportItems
                            title={"دریافت گزارش جامع اطلاعات صندوق"}
                            downloadExcel={_ => {
                                doDownloadReportFile(ReportsItemTypes.XLSX)
                            }}
                            downloadPdf={_ => {
                                doDownloadReportFile(ReportsItemTypes.PDF)
                            }}
                        />
                    </section>
                </TabPanel>
            </TabContext>
        </section>
    )
}
export default CashInfo


const tabTypes = {
    INFO: "INFO",
    REPORTS: "REPORTS",
}
